export enum RestaurantUrl {
    ONLY_TAKEAWAY = 1,
    ONLY_DELIVERY,
    ONLY_DINE_IN,
    ONLY_BOOK,
    BASE = 100
}
